import type { BundleMessageNote } from './BundleMessageNote.js';
import type { BundleMessageLocation } from './BundleMessageLocation.js';

/** Error or warning message generated while bundling. */
export interface BundleMessage {
  text: string;
  /** Bundler or step that generated this message. */
  source: string;
  /** File location the issue originated from. */
  location?: BundleMessageLocation;
  notes?: BundleMessageNote[];
}
